import _ from "lodash";
import { kDefaultProduct } from "../products/defaults";
import { tProductDetailsState } from "./types";

export const getDefaultProductDetailsState = (): tProductDetailsState => _.cloneDeep(kDefaultProductDetailsState);

const kDefaultProductDetailsState: tProductDetailsState = {
  productData: kDefaultProduct,
  variantSelections: {},
  productImages: [],
  displayImage: "",
  quantity: 1,
  rawQuantity: undefined,
  showTester: false,
  testerPrice: 1,
  testerSelected: false,
  isAvailable: false,
  wsp: 1,
  msrp: 1,
  inventory: 1,
};
